import {Button, Dialog, DialogFooter} from 'platform/components';
import {Show, VStack} from 'platform/foundation';

import {suffixTestId} from 'shared/web';

import {useFilter} from '../../../hooks/FilterContext';
import i18n from '../../../i18n/i18n';
import {SavedFilters} from '../../Filter/components/SavedFilters/SavedFilters';
import {Filter, FilterProps} from '../../Filter/Filter';

interface FilterModalProps extends FilterProps {
  onReset: () => void;
}

export function FilterModal(props: FilterModalProps) {
  const context = useFilter();

  return (
    <Dialog
      title={i18n.t('page.advertisiments.filter')}
      isOpen={context.isOpenMobileFilter}
      onClose={context.closeMobileFilter}
      size="xLarge"
      withAdditionalFooter
      scrollBehavior="inside"
      data-testid={suffixTestId('dialog', props)}
    >
      <VStack spacing={4} data-testid={suffixTestId('contentWrapper', props)}>
        <Show when={props.isSavedFiltersExternal}>
          <SavedFilters
            priceReport={props.priceReport}
            formApi={props.formApi}
            onFilterChange={() => props.formControl.onChange?.()}
            data-testid={suffixTestId('savedFilters', props)}
          />
        </Show>
        <Filter
          priceReport={props.priceReport}
          formControl={props.formControl}
          formApi={props.formApi}
          isSavedFiltersExternal={props.isSavedFiltersExternal}
          data-testid={suffixTestId('filter', props)}
        />
      </VStack>
      <DialogFooter data-testid={suffixTestId('modalFooter', props)}>
        <VStack spacing={4}>
          <Button
            onClick={props.onReset}
            variant="secondary"
            leftIcon="navigation/refresh"
            title={i18n.t('entity.filterForm.restore')}
            isFullWidth
            data-testid={suffixTestId('resetButton', props)}
          />
          <Button
            onClick={context.closeMobileFilter}
            variant="primary"
            leftIcon="content/filter_list"
            title={i18n.t('entity.filterForm.filter')}
            isFullWidth
            data-testid={suffixTestId('confirmButton', props)}
          />
        </VStack>
      </DialogFooter>
    </Dialog>
  );
}
